module.exports = __webpack_public_path__ + "img/cm4.700951c7.png";